import { Coord } from "../../../../../../../src/types/Interface";
import { ShapeType } from "../../../types/Enum";

interface ShapeGeometry {
	shapePoints: Coord[],
	centerPoint: Coord
}

export default function genShapeCoords(type: ShapeType, startCoord: Coord): ShapeGeometry{
  if(type == ShapeType.l) {
		return genL(startCoord);
	} else if( type == ShapeType.parallel) {
		return genParallel(startCoord);
	} else if(type == ShapeType.rectangle) {
		return genRect(startCoord);
	} else if(type == ShapeType.rightTrapezoid) {
		return genRightTrapezoid(startCoord);
	} else if(type == ShapeType.rightTriangle) {
		return genRightTri(startCoord);
	} else if(type == ShapeType.square) {
		return genSquare(startCoord);
  } else if (type == ShapeType.t) {
		return genT(startCoord);
	} else if(type == ShapeType.trapezoid) {
		return genTrapezoid(startCoord);
	} else if(type == ShapeType.triangle) {
		return genTri(startCoord);
	}
	return genSquare(startCoord);
}

function genL(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints:[
			startCoord,
			{	x: startCoord.x + 1, y: startCoord.y },
			{	x: startCoord.x + 1, y: startCoord.y + 2 },
			{ x: startCoord.x + 2, y: startCoord.y + 2 },
			{	x: startCoord.x + 2, y: startCoord.y + 3 },
			{	x: startCoord.x, y: startCoord.y + 3 }
		],
		centerPoint: { x: startCoord.x + .5, y: startCoord.y + 2.5}
}
}

function genT(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints: [
			startCoord,
			{ x: startCoord.x + 3, y: startCoord.y },
			{ x: startCoord.x + 3, y: startCoord.y + 1 },
			{ x: startCoord.x + 2, y: startCoord.y + 1 },
			{ x: startCoord.x + 2, y: startCoord.y + 3 },
			{ x: startCoord.x + 1, y: startCoord.y + 3 },
			{ x: startCoord.x + 1, y: startCoord.y + 1 },
			{ x: startCoord.x, y: startCoord.y + 1 }
		],
		centerPoint: { x: startCoord.x + 1.5, y: startCoord.y + .5 }
	}
}

function genParallel(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints: [
			startCoord,
			{ x: startCoord.x + 2, y: startCoord.y },
			{ x: startCoord.x + 1, y: startCoord.y + 3 },
			{ x: startCoord.x - 1, y: startCoord.y + 3 }
		],
		centerPoint: { x: startCoord.x + .5, y: startCoord.y + 1.5 }
	}
}

function genRect(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints: [
			startCoord,
			{ x: startCoord.x + 3, y: startCoord.y },
			{ x: startCoord.x + 3, y: startCoord.y + 2},
			{ x: startCoord.x, y: startCoord.y + 2 }
		],
		centerPoint: { x: startCoord.x + 1.5, y: startCoord.y + 1 }
	}
}

function genSquare(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints: [
			startCoord,
			{ x: startCoord.x + 2, y: startCoord.y },
			{ x: startCoord.x + 2, y: startCoord.y + 2},
			{ x: startCoord.x, y: startCoord.y + 2},
		],
		centerPoint: { x: startCoord.x + 1, y: startCoord.y + 1 }
	}
}

function genTri(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints: [
			startCoord,
			{ x: startCoord.x + 2, y: startCoord.y + 3 },
			{ x: startCoord.x - 2, y: startCoord.y + 3 },
		],
		centerPoint: { x: startCoord.x, y: startCoord.y + 2 }
	}
}

function genRightTri(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints: [
			startCoord,
			{ x: startCoord.x + 2, y: startCoord.y + 3 },
			{ x: startCoord.x, y: startCoord.y + 3 },
		],
		centerPoint: { x: startCoord.x + .5, y: startCoord.y + 2 }
	}
}

function genTrapezoid(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints: [
			startCoord,
			{ x: startCoord.x + 2, y: startCoord.y },
			{ x: startCoord.x + 3, y: startCoord.y + 3 },
			{ x: startCoord.x - 1, y: startCoord.y + 3 },
		],
		centerPoint: { x: startCoord.x + 1, y: startCoord.y + 1.5 }
	}
}

function genRightTrapezoid(startCoord: Coord): ShapeGeometry {
	return {
		shapePoints: [
			startCoord,
			{ x: startCoord.x + 2, y: startCoord.y },
			{ x: startCoord.x + 3, y: startCoord.y + 3 },
			{ x: startCoord.x, y: startCoord.y + 3}
		],
		centerPoint: { x: startCoord.x + 1, y: startCoord.y + 1.5 }
	}
}